import React, { useState, useEffect } from 'react';
import CHICTemplate from './CHICTemplate';
import { UpdatedCHICParticipants } from '../../../Constants/Data';

const CHIC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerView, setItemsPerView] = useState(3);

  useEffect(() => {
    const updateItemsPerView = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setItemsPerView(1);
      } else if (width < 1024) {
        setItemsPerView(2);
      } else {
        setItemsPerView(3);
      }
    };

    updateItemsPerView();
    window.addEventListener('resize', updateItemsPerView);

    return () => {
      window.removeEventListener('resize', updateItemsPerView);
    };
  }, []);

  const totalPages = Math.ceil(UpdatedCHICParticipants.length / itemsPerView);
  const maxIndex = UpdatedCHICParticipants.length - itemsPerView;

  const nextSlide = () => {
    setCurrentIndex((prev) => {
      const nextIndex = prev + itemsPerView;
      return nextIndex > maxIndex ? maxIndex : nextIndex;
    });
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => Math.max(prev - itemsPerView, 0));
  };

  const canGoPrev = currentIndex > 0;
  const canGoNext = currentIndex < maxIndex;

  const activeDotIndex = currentIndex >= maxIndex
    ? totalPages - 1
    : Math.floor(currentIndex / itemsPerView);

  return (
    <div
      className="w-full flex flex-col pb-10 3xl:pb-16 3xl:py-16 px-[60px] 3xl:px-[120px] relative"
      style={{ backgroundImage: `url(https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/CHIC_BG.jpg)` }}
    >
      <div className="mt-[36px]">
        <h2 className="font-allroundgothic font-[600] text-[36px] 1.5xl:text-[59px] text-innovationTitle text-center">
          Innovation Spotlight
        </h2>
        <p className="mt-6 text-[18px] font-proximanova text-innovationSubtitle text-center">
          Meet the participants of the CharmHealth Innovation Challenge
        </p>
      </div>


      <div className="w-full mt-8 relative">
        <button
          onClick={prevSlide}
          disabled={!canGoPrev}
          className={`absolute left-0 1.5xl:left-[-40px] 3xl:left-[-80px] top-1/2 transform -translate-y-1/2 z-10 transition-opacity ${!canGoPrev ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:opacity-70'
            }`}
        >
          <svg width="22" height="22" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.883618 8.59285C0.883618 8.36756 0.987368 8.14232 1.20966 7.9645L10.1018 0.85064C10.5316 0.506818 11.243 0.506818 11.6728 0.85064C12.1026 1.19446 12.1026 1.76358 11.6728 2.10742L3.56609 8.59277L11.6728 15.0781C12.1026 15.422 12.1026 15.9911 11.6728 16.3349C11.243 16.6787 10.5316 16.6787 10.1018 16.3349L1.20966 9.22105C0.987373 9.04322 0.883618 8.81792 0.883618 8.59269V8.59285Z" fill="#ffa400" />
          </svg>
        </button>

        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{
              transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)`
            }}
          >
            {UpdatedCHICParticipants.map((participant, index) => (
              <div
                key={index}
                className="flex-shrink-0 px-[20px] 3xl:px-[40px]"
                style={{ width: `${100 / itemsPerView}%` }}
              >
                <CHICTemplate
                  name={participant.name}
                  thumbnail={participant.thumbnail}
                  description={participant.description}
                  label={participant.label}
                  website={participant.website}
                />
              </div>
            ))}
          </div>
        </div>

        <button
          onClick={nextSlide}
          disabled={!canGoNext}
          className={`absolute right-0 1.5xl:right-[-40px] 3xl:right-[-80px] top-1/2 transform -translate-y-1/2 z-10 transition-opacity ${!canGoNext ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:opacity-70'
            }`}
        >
          <svg width="22" height="22" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.9953 8.59269C11.9953 8.81799 11.8915 9.04322 11.6693 9.22105L2.77709 16.3349C2.34732 16.6787 1.63592 16.6787 1.20612 16.3349C0.776345 15.9911 0.776345 15.422 1.20612 15.0781L9.31282 8.59277L1.20612 2.10742C0.776345 1.7636 0.776345 1.19448 1.20612 0.85064C1.6359 0.506818 2.3473 0.506818 2.77709 0.85064L11.6693 7.9645C11.8915 8.14233 11.9953 8.36762 11.9953 8.59285V8.59269Z" fill="#ffa400" />
          </svg>
        </button>

        <div className="flex justify-center mt-8 gap-2">
          {Array.from({ length: totalPages }).map((_, index) => (
            <button
              key={index}
              onClick={() => {
                const targetIndex = index * itemsPerView;
                setCurrentIndex(index === totalPages - 1 ? maxIndex : Math.min(targetIndex, maxIndex));
              }}
              className={`w-2 h-2 rounded-full transition-all ${activeDotIndex === index
                ? 'bg-[#ffa400] w-8'
                : 'bg-white/50'
                }`}
            />
          ))}
        </div>
      </div>

      <a
        href="https://charmhealthchallenge.com"
        className="flex items-center mt-12 3xl:mt-16 w-fit mx-auto no-underline"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="text-white font-proximanova text-[18px] bg-transparent rounded-full px-16 py-2 border-[1px] w-fit mx-auto hover:bg-white/10 transition-colors">
          Learn more about CHIC
        </button>
      </a>
    </div>
  );
};

export default CHIC;